<!--
 * @Description: 综合绩效管理 重要度排序
 * @Author: maqinghe 
 * @Date: 2023年06月27日 10:15:49
-->
<template>
  <div class='importance-page atb-flex atb-flex-column'>
    <div class='container atb-content-bg atb-flex atb-flex-column'>
      <div class='table-content atb-flex atb-flex-column'>
        <vxe-grid
          class='atb-table header-table edit-table border-table'
          border='full'
          stripe
          height='100%'
          auto-resize
          :data="tableData"
          ref="tableGrid"
          :columns="columns"
          :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeCellMethod }"
          :column-config="{ resizable: true }"
          @edit-closed="editClosed"
          :edit-rules="validRules"
        >
          <template v-for="col in dynamicColumns" v-slot:[col.field]="{ row }">
            <!-- <el-select v-model="row[col.field]">
              <el-option v-for="score in scoreList" :key="score.value" :label="score.value" :value="score.value"></el-option>
            </el-select> -->
            <!-- <vxe-select v-model="row[col.field]" placeholder="请选择" transfer>
              <vxe-option v-for="score in scoreList" :key="score.value" :value="score.value" :label="score.value"></vxe-option>
            </vxe-select> -->
            <el-autocomplete
              @change="rowScoreChange(row, col.field)"
              v-model.trim="row[col.field]"
              :fetch-suggestions="scoreSearch"
              @select="(itemScore) => handleScoreSelect(itemScore, row)"
              maxlength="3"
              popper-class="score-select-panel"
            ></el-autocomplete>
          </template>
          <template v-for="col in dynamicColumns" v-slot:[col.headerSlot]="{ column }">
            <span>{{ column.title }}</span>
            <el-popover
              width="300"
              trigger="hover"
              v-if="col.remark"
            >
              <span slot="reference" class="factor-tip"><i class="el-icon-info"></i></span>
              <pre class="factor-tip-content">
                {{ col.remark }}
              </pre>
            </el-popover>
          </template>
          <template v-slot:remark="{ row }">
            <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" autosize v-model="row.remark"></el-input>
          </template>
          <template v-slot:scoreHeader="{ column }">
            <div style="display: inline-block;">
              <span>{{ column.title }}</span>
              <span>(</span>
              <el-popover
                width="600"
                trigger="hover"
              >
                <span slot="reference" class="rank-tip">评分标准</span>
                <table class="rank-tip-table">
                  <thead>
                    <tr>
                      <th width="60" align="center">标准</th>
                      <th width="80" align="center">分值区间</th>
                      <th align="center">标准说明</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td align="center">出色</td>
                      <td align="center">100<br/>95</td>
                      <td>日常工作始终高标准完成，能独立解决工作中出现的所有问题，并能为其找出最优解，减少问题出现。通常具有下列表现：始终高质量、高效率完成工作，能独立解决工作问题并使其减少，得到来自客户的高度评估。</td>
                    </tr>
                    <tr>
                      <td align="center">优良</td>
                      <td align="center">90<br/>85</td>
                      <td>日常工作经常高标准完成，并能独立解决工作中出现的所有问题。常具有下列表现：经常高质量、高效率完成日常工作，可及时解决工作中出现的问题，客户满意。</td>
                    </tr>
                    <tr>
                      <td align="center">可接受</td>
                      <td align="center">80<br/>75</td>
                      <td>日常工作可以正常完成，并能独立解决工作中出现的大部分问题。通常具有下列表现；日常工作可以达到工作标准，可解决工作中出现的问题，客户基本满意。</td>
                    </tr>
                    <tr>
                      <td align="center">需改进</td>
                      <td align="center">70<br/>65</td>
                      <td>基本满足日常工作的需要，在别人的帮助下才能解决工作中出现的问题。通常具有下列表现：偶有小的疏漏，有时达不到工作标准，偶尔有客户的投诉，工作中的问题完全无法独立解决。</td>
                    </tr>
                    <tr>
                      <td align="center">不良</td>
                      <td align="center">60<br/>30<br/>0</td>
                      <td>不能满足日常工作的需要，通常具有以下表现：经常出现工作失误，达不到工作标准，经常有投诉发生。</td>
                    </tr>
                  </tbody>
                </table>
              </el-popover>
              <span>)</span>
            </div>
          </template>
          <template v-slot:rankHeader="{ column }">
            <div>
              <span>{{ column.title }}</span>
              <span>(</span>
              <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                :content="rankContent">
                <span slot="reference" class="rank-tip">注意事项</span>
                <pre style="white-space: pre-line;">
                  {{ rankContent }}
                </pre>
              </el-popover>
              <span>)</span>
            </div>
          </template>

          <template v-slot:isRatingCurntEdit="{ row }">
            <el-select v-model="row.isRatingCurnt">
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </template>
          <template v-slot:noRatingReasonEdit="{ row }">
            <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" autosize v-model="row.noRatingReason"></el-input>
          </template>

          <template v-slot:operation="{ row }">
            <el-tooltip class='item' effect='dark' content='编辑' placement="bottom">
              <i class='icon-editor' @click.stop="importanceEdit(row)"></i>
            </el-tooltip>
          </template>
        </vxe-grid>
      </div>
    </div>

  </div>
</template>
<script>
  import _ from 'lodash';
  import { PERIODS, IMPORTANCE_STATE } from '@/utils/period-enum.js';
  export default {
    name: "Importance",
    inject: ["reload"],
    components: {
      selecter: () => import('@/component/global/customerSelect'),
    },
    props: {
      propData: {
        type: Object,
        default: () => ({})
      },
    },
    data() {
      return {
        validRules: {},
        statusMap: IMPORTANCE_STATE,

        periods: PERIODS,

        year: undefined,
        period: undefined,
        cacheEditValue: '',
        tableData: [],
        cacheTableData: [],
        defaultColumns: [
          { type: 'seq', title: 'NO.', width: 50 },
          { field: 'period', title: '期次', width: 100, formatter: ({row}) => {return `${row.year}${this.periods[row.period]}`}  },
          { field: 'wkName', title: '姓名', width: 140, formatter: ({row}) => {return `${row.wkName}(${row.wkNo})`} },
          { field: 'score', title: '总分', width: 130, slots: { header: 'scoreHeader' } },
          { field: 'sort', title: '排名', width: 130, slots: { header: 'rankHeader' } },
          { field: 'remark', title: '备注', minWidth: 150, isEditable: true, editRender: { autofocus: '.el-textarea__inner' }, slots: { edit: 'remark' } },
          { field: 'isRatingCurnt', title: '是否参评', editRender: { autofocus: '.el-input__inner' }, slots: { edit: 'isRatingCurntEdit'}, formatter: ({row}) => {return row.isRatingCurnt ? '是' : '否'}, width: 80 },
          { field: 'noRatingReason', title: '不参评原因', editRender: { autofocus: '.el-textarea__inner' }, slots: { edit: 'noRatingReasonEdit'}, minWidth: 150 },
          { field: '', title: '操作', width: 80, fixed: 'right', slots: {default: 'operation'}, className: 'operation' },
        ],
        dynamicColumns: [],
        columns: [],

        rankContent: '',

        scoreList: [
          { value: 100 },
          { value: 95 },
          { value: 90 },
          { value: 85 },
          { value: 80 },
          { value: 75 },
          { value: 70 },
          { value: 60 },
          { value: 30 },
          { value: 0 }
        ],

      }
    },

    watch: {
      $route(){
        this.reload();
      },
      // 因素列添加校验函数
      dynamicColumns: {
        handler(newValue) {
          this.validRules = {};
          if (newValue && newValue.length > 0) {
            newValue.forEach(column => {
              this.validRules[column.field] = [
                {
                  required: true,
                  validator: ({cellValue, row}) => {
                    if (!cellValue && cellValue !== 0) {
                      return new Error(column.name + '必填')
                    } else if (!this.scoreList.find(item => item.value == cellValue)) {
                      return new Error('未输入下拉分值')
                    }
                  }
                }
              ]
            });
          }
        },
        immediate: true
      }
    },
    created() {
      this.getDictData();
    },
    mounted() {
      this.getData();
    },
    methods: {
  
      validateScore(row, field) {
        let val = row[field];
        if(!val) val = '0';
        val = val.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        val = val && parseFloat(val);
        if (val - 0 > 100) {
          val = 100;
        }
        if (val - 0 < 0) {
          val = 0;
        }
        row[field] = val;
      },
      validateInt(row, field) {
        let val = row[field];
        if (val) val = Math.abs(parseInt(val));
        row[field] = val;
      },

      getDictData() {
        this.$ajax.get(this.$api.common.getDict, { ItemType: 'ImportanceFactorRemark' }).then((res)=>{
          if(res.code === 0) {
            let list = (res.data && res.data.rows) || [];
            list.forEach(item => {
              switch (item.itemKey) {
                case 'ScoreSort':
                  this.rankContent = item.itemDesc;
                  break;
                default:
                  break;
              }
            });
          }
        });
      },
      getData() {
        Promise.all([this.getFactorColumn(), this.getList()]).then(res => {
          const factorColumns = res[0];
          const commitedFactorColumns = res[1];
          if (commitedFactorColumns && commitedFactorColumns.length > 0) {
            this.dynamicColumns = commitedFactorColumns;
          } else {
            this.dynamicColumns = factorColumns;
          }
          this.concatColumn();
        });
      },
      // 获取因素列，未提交时取此接口数据
      getFactorColumn() {
        return this.$ajax.get(this.$api.period.importanceFactor.column, {
          WkNo: this.propData.configWkNo,
        }).then((res) => {
          let list = res.data.importanceFactorListDto || [];
          list.sort((a, b) => (a.type - b.type || a.sort - b.sort));
          let columns = [];
          list.forEach(item => {
            columns.push({
              field: item.id,
              title: `${item.factorName}(${item.factorWeight}%)`,
              name: item.factorName,
              weight: item.factorWeight,
              sort: item.sort,
              width: 175,
              isEditable: true,
              remark: item.remark,
              type: item.type
            });
          });
          return columns;
        });
      },
      // 固定列、动态列(因素)合并
      concatColumn() {

        if (!this.propData.configWkNo) {
          this.dynamicColumns = this.dynamicColumns.filter(item => item.type === 0);
        }

        // 动态列添加可编辑处理
        this.dynamicColumns.forEach(col => {
          if (col.isEditable) {
            this.$set(col, 'editRender', { autofocus: '.el-input__inner' });
            this.$set(col, 'slots', { edit: col.field, header: `${col.field}Header` });
            this.$set(col, 'headerSlot', `${col.field}Header`);
          }
        });
        let cols = [...this.defaultColumns.slice(0, 3), ...this.dynamicColumns, ...this.defaultColumns.slice(3)];
        this.columns = cols;
      },
      
      // 获取表格数据
      getList() {
        this.tableData = [];
        let param = {superiorNo: this.propData.superiorNo, configWkNo: this.propData.configWkNo, year: this.propData.year || undefined, period: this.propData.period || undefined};
        return this.$ajax.post(this.$api.period.manage.importanceData, param).then((res) => {
          let rows = res.data.rows.importantSort || [];
          this.approveReasonText = rows.length > 0 ? rows[0].approveReason : '';
          
          rows.forEach(row => {
            let factorScoreList = row.importanceScoreList || [];
            factorScoreList.forEach(factor => {
              row[factor.factorId] = factor.itemScore;
            });
          });
          this.total = res.data.total;
          this.tableData = rows;
          this.cacheTableData = _.cloneDeep(rows);

          // 提交后的因素列，取此字段，不取因素列接口的数据
          let commitedFactors = res.data.rows.selfFactors || '[]';
          commitedFactors = JSON.parse(commitedFactors);
          let columns = [];
          if (commitedFactors.length > 0) {
            commitedFactors.forEach(item => {
              columns.push({
                field: item.Id,
                title: `${item.FactorName}(${item.FactorWeight}%)`,
                name: item.FactorName,
                weight: item.FactorWeight,
                sort: item.Sort,
                width: 175,
                remark: item.Remark,
                isEditable: true,
                type: item.Type
              });
            });
          }
          columns.sort((a, b) => (a.type - b.type || a.sort - b.sort));
          return columns;
        });
      },

      activeCellMethod({ row }) {
        // 缓存当前行的值，如果没有变动，则不调接口
        let cacheRow = {};
        this.dynamicColumns.forEach(col => {
          cacheRow[col.field] = row[col.field];
        });
        cacheRow.remark = row.remark;
        cacheRow.sortId = row.id;
        cacheRow.remark = row.remark;
        cacheRow.isRatingCurnt = row.isRatingCurnt;
        cacheRow.noRatingReason = row.noRatingReason;
        this.cacheEditValue = cacheRow;
        return true;
      },
      async editClosed({row, rowIndex}) {
        if (this.buttonSave) {
          return false;
        }
        let isValidError = false;
        for (let i = 0; i < this.dynamicColumns.length; i++) {
          const field = this.dynamicColumns[i].field;
          if (row[field] !== 0 && row[field]) {
            const score = this.scoreList.find(item => item.value === row[field])
            if (!score) {
              isValidError = true;
              break;
            }
          }
        }
        if (isValidError) {
          this.$refs.tableGrid.validate(row);
          return false;
        }
        
        let currentRow = {};
        this.dynamicColumns.forEach(col => {
          currentRow[col.field] = row[col.field];
        });
        currentRow.remark = row.remark;
        currentRow.sortId = row.id;
        currentRow.remark = row.remark;
        currentRow.isRatingCurnt = row.isRatingCurnt;
        currentRow.noRatingReason = row.noRatingReason;
        if (JSON.stringify(this.cacheEditValue) === JSON.stringify(currentRow) || this.cacheEditValue.sortId !== currentRow.sortId) {
          return false;
        }
        this.buttonSave = true;
        this.$confirm('确定要修改吗', '修改', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          closeOnClickModal: false,
          closeOnPressEscape: false,
        })
        .then(() => {
          this.buttonSave = false;

          let factors = [];
          this.dynamicColumns.forEach(col => {
            if (row[col.field] || row[col.field] === 0) {
              factors.push({
                factorId: col.field,
                itemScore: row[col.field] === '' ? undefined : row[col.field]
              });
            }
          });
          let params = {
            itemScoreList: factors,
            remark: row.remark,
            sortId: row.id,
            remark: row.remark,
            isRatingCurnt: row.isRatingCurnt,
            noRatingReason: row.noRatingReason
          };
          this.$ajax.post(this.$api.period.manage.importanceUpdate, params).then(() => {
            this.$message.success("保存成功");
            this.getList();
          });
        })
        .catch(() => {
          this.buttonSave = false;
          this.$set(this.tableData, rowIndex, _.cloneDeep(this.cacheTableData[rowIndex]))
        });

      },
      importanceEdit(row) {
        this.$refs['tableGrid'].setActiveRow(row);
      },
      rowScoreChange(row, field) {
        let val = row[field];
        if (!val) val = "";
        val = val.replace(/[^\d]/g, '');
        val = val && parseInt(val);
        if (val - 0 > 100) {
          val = 100;
        }
        if (val - 0 < 0) {
          val = 0;
        }
        row[field] = val;
        this.$refs.tableGrid.validate(row);
      },
      scoreSearch(queryString, cb) {
        let programList = this.scoreList;
        // 调用 callback 返回建议列表的数据
        cb(programList);
      },
      handleScoreSelect(score, row) {
        this.$refs.tableGrid.validate(row);
      },
    },
    
  }
</script>
<style scoped lang='scss'>
  .importance-page {
    height: 500px;
    .container {
      margin-top: 15px;
      padding: 24px;
      flex: 1;
      ::v-deep .atb-table {
        .main-row {
          .vxe-cell {
            padding: 0;
          }
        }
      }
    }
    ::v-deep .el-dialog__body {
      padding-top: 20px !important;
      text-align: left;
      .sub-content{
        text-align: center;
      }
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: right;
    }
  }
  .footer {
    text-align: right;
    margin-top: 20px;
  }
  .add-factor {
    margin-left: 5px;
    font-size: 16px;
    cursor: pointer;
    color: $--color-primary;
    vertical-align: -1px;
    &:hover {
      opacity: 0.8;
    }
  }
  .rank-tip {
    color: $--color-primary;
  }
  .rank-tip-table {
    border-collapse: collapse;
    font-size: 13px;
    color: #222;
    td, th {
      padding: 10px ;
      border: 1px solid #ccc;
    }
  }
  .factor-tip {
    margin-left: 2px;
    color: #aaa;
    vertical-align: bottom;
    &:hover {
      color: #888;
    }
  }
  .factor-tip-content {
    color: #222;
    white-space: pre-line;
  }
</style>
<style>
.vxe-select--panel.is--transfer {
  z-index: 4000!important;
}
.el-autocomplete-suggestion.score-select-panel {
  margin: 6px 0;
}
</style>